export class TelegramIntegration {
    constructor() {
        this.isAvailable = false;
        this.webApp = null;
        this.user = null;

        this.init();
    }

    init() {
        // Check if running in Telegram WebApp
        if (window.Telegram && window.Telegram.WebApp) {
            this.webApp = window.Telegram.WebApp;
            this.isAvailable = true;

            // Expand to full height
            this.webApp.expand();

            // Get user info
            this.user = this.webApp.initDataUnsafe.user;

            // Enable closing confirmation
            this.webApp.enableClosingConfirmation();

            // Set header color
            this.webApp.setHeaderColor('#0a0e27');
            this.webApp.setBackgroundColor('#1a1a2e');
        }
    }

    getPlayerName() {
        if (this.user) {
            return this.user.first_name || this.user.username || 'Player';
        }
        return this.getLocalPlayerName();
    }

    getLocalPlayerName() {
        let name = localStorage.getItem('playerName');
        if (!name) {
            name = 'Player' + Math.floor(Math.random() * 1000);
            localStorage.setItem('playerName', name);
        }
        return name;
    }

    setLocalPlayerName(name) {
        const trimmed = name.trim().slice(0, 20) || 'Player';
        localStorage.setItem('playerName', trimmed);
        return trimmed;
    }

    async purchaseWithStars(itemName, price, onSuccess, onError) {
        if (!this.isAvailable) {
            if (onError) onError('Telegram WebApp not available. Purchase simulated for testing.');
            // Simulate purchase for testing
            if (onSuccess) onSuccess();
            return;
        }

        try {
            // Create invoice
            const invoice = {
                title: itemName,
                description: `Purchase ${itemName} for ${price} Stars`,
                payload: JSON.stringify({ item: itemName }),
                provider_token: '', // Stars payments don't need a provider token
                currency: 'XTR', // Telegram Stars currency code
                prices: [
                    {
                        label: itemName,
                        amount: price
                    }
                ]
            };

            // Open invoice
            this.webApp.openInvoice(invoice.link, (status) => {
                if (status === 'paid') {
                    if (onSuccess) onSuccess();
                } else if (status === 'cancelled') {
                    if (onError) onError('Payment cancelled');
                } else {
                    if (onError) onError('Payment failed');
                }
            });
        } catch (error) {
            if (onError) onError(error.message);
        }
    }

    shareScore(score, kills) {
        const text = `🎮 I scored ${score} points and defeated ${kills} enemies in Survival Game! Can you beat my score?`;

        if (this.isAvailable) {
            this.webApp.shareScore(text);
        } else {
            // Fallback to Web Share API
            if (navigator.share) {
                navigator.share({
                    title: 'Survival Game',
                    text: text
                }).catch(err => console.log('Error sharing:', err));
            } else {
                console.log('Share not available');
            }
        }
    }

    showAlert(message) {
        if (this.isAvailable) {
            this.webApp.showAlert(message);
        } else {
            alert(message);
        }
    }

    showConfirm(message, callback) {
        if (this.isAvailable) {
            this.webApp.showConfirm(message, callback);
        } else {
            const result = confirm(message);
            callback(result);
        }
    }

    hapticFeedback(type = 'impact') {
        if (this.isAvailable && this.webApp.HapticFeedback) {
            if (type === 'impact') {
                this.webApp.HapticFeedback.impactOccurred('medium');
            } else if (type === 'success') {
                this.webApp.HapticFeedback.notificationOccurred('success');
            } else if (type === 'error') {
                this.webApp.HapticFeedback.notificationOccurred('error');
            }
        }
    }

    close() {
        if (this.isAvailable) {
            this.webApp.close();
        }
    }
}
